import React from "react";
import { Autocomplete, Box, Checkbox, FormControl, FormControlLabel, FormGroup, TextField } from "@mui/material";

const MultiSelectCheckboxFilter = ({ item, applyValue, options }) => {
  const handleChange = (event, newValue) => {
    applyValue({ ...item, value: newValue });
  };

  return (
    <Autocomplete
      className="tableChip"
      multiple
      disableCloseOnSelect
      options={options}
      value={item.value || []}
      onChange={handleChange}
      getOptionLabel={(option) => option}
      renderOption={(props, option, { selected }) => (
        <li
          {...props}
          style={{ display: "flex", padding: "0px 2px", fontSize: "12px" }}
        >
          <Checkbox
            checked={selected}
            size="small"
            style={{ marginRight: 8, padding: "0px" }}
          />
          {option}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label="Value"
          placeholder="Filter value"
          InputLabelProps={{
            shrink: true,
          }}
          sx={{
            "& .MuiChip-root": {
              justifyContent: "center",
              height: "20px",
              color: "#333",
              fontSize: "9px",
            },
          }}
        />
      )}
    />
  );
};

export const createMultiSelectOperator = (options) => ({
  label: "is any of",
  value: "multiSelect",
  getApplyFilterFn: (filterItem) => {
    if (!filterItem.value || filterItem.value.length === 0) {
      return null;
    }
    return (params) => filterItem.value.includes(params.value);
  },
  InputComponent: (props) => (
    <MultiSelectCheckboxFilter {...props} options={options} />
  ),
});

// filter input component: Multi checkbox with labels
function MultiSelectCheckboxFilterForBoolean(props) {
  const { item, applyValue, options } = props;

  const selected = Array.isArray(item.value) ? item.value : [];

  const toggle = (val) => {
    const next = selected.includes(val)
      ? selected.filter((x) => x !== val)
      : [...selected, val];

    applyValue({ ...item, value: next });
  };

  return (
    <Box sx={{ p: 1 }}>
      <FormControl variant="standard" fullWidth>
        <FormGroup>
          {options.map((opt) => (
            <FormControlLabel
              key={String(opt.value)}
              control={
                <Checkbox
                  size="small"
                  checked={selected.includes(opt.value)}
                  onChange={() => toggle(opt.value)}
                />
              }
              label={opt.label}
            />
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  );
}

// Operator that filters by selected boolean values
export const createMultiSelectOperatorForBoolean = (options) => ({
  label: "is any of",
  value: "multiSelect",
  getApplyFilterFn: (filterItem) => {
    const selected = filterItem.value;
    if (!selected || selected.length === 0) return null;

    return (params) => selected.includes(Boolean(params.value));
  },
  InputComponent: (props) => (
    <MultiSelectCheckboxFilterForBoolean {...props} options={options} />
  ),
});